'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagHkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2.26125e-05C9.33333 -6.87152e-05 18.6667 4.97202e-06 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V2.26125e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V0L0 2.26125e-05V20Z",
          fill: "#F0371D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.984 8.14573C14.9468 7.33985 15.0054 7.15963 15.2361 6.44963C15.3131 6.21265 15.2588 6.018 15.1946 5.78814C15.1021 5.45668 14.9892 5.05199 15.2201 4.34151C14.1696 4.00017 12.949 4.85894 12.4939 6.25962C12.0388 7.6603 12.5215 9.07247 13.572 9.4138C13.76 9.47491 13.739 9.43073 13.6819 9.3111C13.5817 9.1012 13.3707 8.65904 13.984 8.14573ZM14.0436 6.06217C14.2187 6.11906 14.3145 6.30711 14.2576 6.4822C14.2007 6.65728 14.0127 6.7531 13.8376 6.69621C13.6625 6.63932 13.5667 6.45127 13.6236 6.27619C13.6805 6.1011 13.8685 6.00528 14.0436 6.06217Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9901 9.61763C11.5212 8.4529 11.3679 8.34152 10.7639 7.90271C10.5623 7.75625 10.3604 7.74775 10.122 7.73772C9.77819 7.72326 9.35841 7.70559 8.75404 7.26649C8.10479 8.1601 8.54436 9.58628 9.73585 10.4519C10.9273 11.3176 12.4195 11.295 13.0688 10.4013C13.185 10.2414 13.1365 10.2478 13.0051 10.2651C12.7745 10.2955 12.2888 10.3595 11.9901 9.61763ZM10.0269 8.91709C10.1351 8.76815 10.3436 8.73514 10.4925 8.84335C10.6415 8.95156 10.6745 9.16001 10.5663 9.30895C10.4581 9.45788 10.2496 9.4909 10.1007 9.38269C9.95175 9.27448 9.91873 9.06603 10.0269 8.91709Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18 10.2539C17.2535 10.2539 17.064 10.2539 16 9.58719C15.3223 9.16255 14.967 9.49985 14.7983 9.65996C14.7022 9.75122 14.6667 9.78492 14.6667 9.58719C14.6667 8.48262 15.8606 7.58719 17.3333 7.58719C18.8061 7.58719 20 8.48262 20 9.58719C19.253 9.58719 18.903 9.81964 18.6163 10.01C18.4175 10.1421 18.2492 10.2539 18 10.2539ZM18 9.00001C18 9.18411 17.8508 9.33335 17.6667 9.33335C17.4826 9.33335 17.3333 9.18411 17.3333 9.00001C17.3333 8.81592 17.4826 8.66668 17.6667 8.66668C17.8508 8.66668 18 8.81592 18 9.00001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.2521 11.95C14.9468 13.1679 15.0054 13.3481 15.2361 14.0581C15.3131 14.2951 15.4714 14.4206 15.6584 14.5689C15.9281 14.7827 16.2573 15.0437 16.4881 15.7542C17.5387 15.4129 18.0213 14.0007 17.5662 12.6C17.1111 11.1993 15.8906 10.3405 14.84 10.6819C14.652 10.743 14.695 10.7663 14.8115 10.8296C15.0159 10.9405 15.4465 11.1742 15.2521 11.95ZM16.4285 13.6706C16.2535 13.7275 16.0654 13.6317 16.0085 13.4566C15.9516 13.2815 16.0474 13.0935 16.2225 13.0366C16.3976 12.9797 16.5857 13.0755 16.6426 13.2506C16.6994 13.4257 16.6036 13.6137 16.4285 13.6706Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7738 11.9688C11.5212 12.0548 11.3679 12.1662 10.7639 12.605C10.5623 12.7515 10.4919 12.9408 10.4086 13.1645C10.2886 13.487 10.1421 13.8808 9.53775 14.3199C10.187 15.2135 11.6792 15.2362 12.8707 14.3705C14.0622 13.5048 14.5018 12.0787 13.8525 11.1851C13.7363 11.0251 13.7274 11.0732 13.7032 11.2036C13.6609 11.4322 13.5717 11.914 12.7738 11.9688ZM11.5009 13.6194C11.3927 13.4704 11.4257 13.262 11.5747 13.1538C11.7236 13.0456 11.9321 13.0786 12.0403 13.2275C12.1485 13.3765 12.1155 13.5849 11.9665 13.6931C11.8176 13.8013 11.6091 13.7683 11.5009 13.6194Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagHkAsset = forwardRef(FlagHkAsset);

export { VpFlagHkAsset as default };
